module.exports = "<wor-table\n  [data]=\"record.history_items\"\n  [settings]=\"tableSettings\"\n  *ngIf=\"record.history_items.length\">\n</wor-table>";